import { IdentityDocument } from '../model'
import { Country } from '@afterpaytouch/portal-api'
import { useFlag } from '@afterpaytouch/feature'

const DEFAULT_DOCUMENTS: IdentityDocument[] = ['licence', 'passport']
const DEFAULT_ALLOWED_DOCUMENTS = {
  [Country.AU]: ['licence', 'medicare', 'passport'],
}

export const useAllowedDocumentsByCountry = (country: Country): IdentityDocument[] => {
  const allowedDocuments = useFlag('allowed-documents-by-country', DEFAULT_ALLOWED_DOCUMENTS)

  return allowedDocuments[country] || DEFAULT_ALLOWED_DOCUMENTS[country] || DEFAULT_DOCUMENTS
}
